module.exports = __webpack_public_path__ + "ce6dcdbf55ef0ccb4dda347487c4a81a.ttf";